import { useState } from 'react'
import { KnowledgeSource } from '~/features/knowledge-bases/types'

export const useKnowledgeBaseSelection = (knowledgeSources: KnowledgeSource[], dsIds?: string[]) => {
  const _dsIds = dsIds || []
  const [selectedKnowledgeSources, setSelectedKnowledgeSources] = useState<
    Record<'knowledgeSource' | 'webPageSource', string[]>
  >({ knowledgeSource: [], webPageSource: [] })

  const selectedKnowledgeSourcesCount =
    selectedKnowledgeSources.knowledgeSource.length + selectedKnowledgeSources.webPageSource.length

  const [currentIndex, setCurrentIndex] = useState<number>(-1)

  function clearSelectedKnowledgeSources() {
    setSelectedKnowledgeSources({ knowledgeSource: [], webPageSource: [] })
  }

  function handleMultiSelection(index: number) {
    if (currentIndex === -1) {
      setCurrentIndex(index)
    } else {
      const start = currentIndex >= index ? index : currentIndex
      const end = currentIndex >= index ? currentIndex : index

      const webPageSlice = _dsIds.slice(start, end + 1)
      const webPageSourceIds = [
        ...selectedKnowledgeSources.webPageSource,
        ...webPageSlice.filter((id) => !selectedKnowledgeSources.webPageSource.includes(id)),
      ]

      if (end >= _dsIds.length) {
        const knowledgeSourceSlice = knowledgeSources.slice(start, end + 1 - _dsIds.length).map((source) => source.id)
        const knowledgeSourceIds = [
          ...selectedKnowledgeSources.knowledgeSource,
          ...knowledgeSourceSlice.filter((id) => !selectedKnowledgeSources.knowledgeSource.includes(id)),
        ]
        setSelectedKnowledgeSources({
          knowledgeSource: knowledgeSourceIds,
          webPageSource: webPageSourceIds,
        })
      } else {
        setSelectedKnowledgeSources({
          ...selectedKnowledgeSources,
          webPageSource: webPageSourceIds,
        })
      }
      setCurrentIndex(-1)
    }
  }

  return {
    selectedKnowledgeSources,
    setSelectedKnowledgeSources,
    selectedKnowledgeSourcesCount,
    currentIndex,
    setCurrentIndex,
    clearSelectedKnowledgeSources,
    handleMultiSelection,
  }
}
